import CartStorage from "../../utils/cartStorage";
import moment from "moment";
import {CheckoutItemsValidator} from "./checkoutItemsValidator";
import {CheckoutGuestsInformationForm} from "./checkoutGuestsInformationForm";
import {CheckoutOrderHandler} from "./checkoutOrderHandler";
import {__loco} from "../../utils/localization";
import {CheckoutGuestsInformationFormProvider} from "./checkoutGuestsInformationFormProvider";
import {CheckoutSummary} from "./summary/CheckoutSummary";
import {calendarIcon} from "../../utils/svg-list";
import { SERVICE_CATEGORIES } from '../../adlevo-vue/appConfiguration';

/**
 * Class for rendering checkout sidebar and handling events and functionality related to checkout sidebar.
 */
export class CheckoutRenderer {

  /**
   * Constructor
   */
  constructor() {
    this.selectors = {
      totalPrice: '.details__content_bottom .price_number',
      totalPriceMobile: '.checkout__mobile_bottom__price-number',
      itemsContainer: '.details__content .details__content_top',
      sidebarWrapper: '.checkout__content .details',
      mainWrapper: '.checkout__wrapper, #mobile-checkout-block',
    };

    this.shouldRenderGuestsForm = true;
  }

  /**
   * Set an optional validator
   *
   * @param {CheckoutItemsValidator} validator
   */
  setValidator(validator) {
    this.validator = validator;
    return this;
  }

  /**
   * Check if renderer has validator
   *
   * @returns {boolean}
   */
  hasValidator() {
    return !!this.validator;
  }

  /**
   * Set an optional cartStorage
   *
   * @param {CartStorage} cart
   */
  setCartStorage(cart) {
    this.cart = cart;
    return this;
  }

  /**
   * Check if renderer has cart storage
   *
   * @returns {boolean}
   */
  hasCartStorage() {
    return !!this.cart;
  }

  /**
   * Set a flag telling if guests form should be redrawn
   *
   * @param shouldRenderGuestsForm
   */
  setShouldRenderGuestsForm(shouldRenderGuestsForm) {
    this.shouldRenderGuestsForm = shouldRenderGuestsForm;
  }

  /**
   * Begin rendering
   *
   * @param response
   */
  begin(response) {
    this.response = response;
    // console.log(response);

    this.renderSidebarItems(response);
    if(this.shouldRenderGuestsForm) {
      this.renderGuestInformation(this.response);
    }
  }

  /**
   * Render only the sidebar
   *
   * @param cartItems
   */
  renderSidebarItems(cartItems)
  {

    /**
     * Remove sidebar loading state
     */
    this.sidebarLoaded();

    if(!cartItems || 0 === cartItems.length){
      this.renderEmptyCart({
        message: 'no Items'
      });
      return;
    }

    const totalCost = cartItems.reduce((total, cartItem) => {
      total += Number(cartItem.getTotal());
      return total;
    }, 0);

    this.renderTotalPrice(totalCost);
    this.renderItems(cartItems);
  }

  /**
   * Render the case when the cart is empty
   *
   * @param response
   */
  renderEmptyCart(response) {
    $('#mobile-checkout-block').hide()
    $('.checkoutPageContent').hide()
    $('#noCartItemSection').removeClass('d-none')

    $('.inputs__title .checkout__h1, .checkout__mobile_title').text(response.message);
    $('.inputs__title_secondary, .checkout__mobile_bottom, .checkout__content .details, .checkout__mobile_navigation__step, .tourDetailCheckoutCard').hide();
    $('#desktop-steps, #mobile-steps').hide();
  }

  /**
   * Render sidebar as 'loading'
   */
  sidebarLoading()
  {
    jQuery(this.selectors.sidebarWrapper).css('opacity', '.3');
  }

  /**
   * Sidebar loaded
   */
  sidebarLoaded()
  {
    $('.checkout__wrapper, .checkout__mobile').removeClass('--hidden');
    $(this.selectors.sidebarWrapper).css('opacity', '1');
  }

  /**
   * Render total price
   *
   * @param price
   */
  renderTotalPrice(price) {
    // @todo: Remove mobile dependency.
    // $(this.selectors.totalPrice).text(price);
    // $(this.selectors.totalPriceMobile).text(price);
  }

  /**
   * Render items
   *
   * @param cartItems
   */
  renderItems(cartItems) {
    let render = [];

    cartItems.forEach(cartItem => {
      render.push(this.renderSingleItem(cartItem));
    })

    const summary = new CheckoutSummary();
    summary.init(cartItems);


    $(this.selectors.itemsContainer).html(render.join(''));

    // TODO check Add Listeners
    // this.attachCartItemListeners();
  }

  /**
   * Attach DOM Listeners for cart item on checkout page
   */
  attachCartItemListeners() {

    const self = this;

    $(document).on('click', '.cart_item__show-more', function(e){
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.details__item');

      self.cartItemShowMore($this, $item);
    });

    $(document).on('click', '.cart_item__remove', function(e){
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.details__item');

      self.cartItemRemove($this, $item);
    })
  }

  /**
   * Remove cart item from UI, and cartStorage optionally request new validated data
   *
   * @param $trigger
   * @param $item
   */
  cartItemRemove($trigger, $item) {
    $item.remove();

    const itemId = $trigger.data('id');

    // attempt removing from cartStorage, then re-validate
    if(this.hasCartStorage()) {
      this.cart.deleteItem(itemId).then((data) => {
        if(this.hasValidator()) {
          this.validator.cartData = data;
          this.validator.validateCartData();
        }
      });
    }
  }

  /**
   * Cart item show more
   *
   * @todo: Not good for translations.
   * @param $trigger
   * @param $item
   */
  cartItemShowMore($trigger, $item) {
      $item.find('.more-section').toggleClass('--opened');

      if ($trigger.text() === __loco('Show more')) {
        $trigger.text(__loco('Show less'));
      } else {
        $trigger.text(__loco('Show more'));
      }
  }

  /**
   * Render one item
   *
   * @param cartItem
   */
  renderSingleItem(cartItem) {
    switch (cartItem.getType()){
      case SERVICE_CATEGORIES.ACTIVITIES:
        return this.renderActivityCartItem(cartItem)

      case SERVICE_CATEGORIES.HOTELS:
        return this.renderHotelCartItem(cartItem)
    }
  }

  renderActivityCartItem(cartItem) {
    const tour       = cartItem.tour;
    const basket     = cartItem.basket;
    const tourOption = cartItem.tour_option;


    const duration = `${tourOption.duration_time_hour}h ${tourOption.duration_time_min} ${__loco('min tour')}`;

    let guestsCount = basket.tickets_count;

    const guests = `${guestsCount} ${__loco('tickets')}`;

    const tourDate = moment(cartItem.request.date).format('ddd, MMM D');

    let startTime = moment(tour.start_time, 'HH:mm:ss').format('hh:mm A');

    /**
     * check if an option was added to cart
     */
    if(cartItem.tour_option !== undefined ) {
      startTime = moment(cartItem.tour_option.start_time, 'HH:mm:ss').format('hh:mm A')
    }

    if(cartItem.tour.is_all_day_tour) {
      startTime = __loco('Any hour');
    }

    /**
     * Flag telling if this item should be rendered as disabled
     */
    let disabled = !cartItem.status;

    /**
     * Will contain errors list
     */
    let errors = [];

    /**
     * Check for price matching errors
     */
    if(!cartItem.price_matching.status) {
      errors.push(`<div class="details__item_error">${cartItem.price_matching.message}</div>`);
    }

    /**
     * Add other errors
     */
    if(!cartItem.status) {
      errors.push(`<div class="details__item_error">${cartItem.message}</div>`);
    }

    return (
      `<article class="availability-tour-card__item border-none mb-2 pb-0">
          <div>
            <h1 class="availability-tour-card__item_title subtitle-2 secondary-text checkoutTourTitle">${tour.name}</h1>
            <div class="row no-gutters light-theme flex-nowrap">
            <div class="col-5 col-lg-4 col-xl-4">
              ${tour.photos.length && !!tour.photos[0].path_url ? `
                <div class="tourImageWrapper">
                  <img class="item__left__slider_img-wrapp__image tourImage"
                       src="${tour.photos[0].path_url}" alt="${tour.name}">
                </div>
              ` : ''}
            </div>
            <div class="col-7 col-lg-8 col-xl-8">
                <div class="availability-tour-card__item_content">
            
            <div class="selected-date">
                <button class="btn btn-default btn-sm btn-outline-dark" disabled>
                  <span class="selected-date-button-icon">
                      ${calendarIcon()}
                  </span>
                  <span class="selected-date-button-value caption">${moment(cartItem.date).format('LL')}</span>
                </button>
            </div>
            
            ${tour.reviews_count > 0 ? `
            <div class="availability-tour-card__item_reviews">
              <div class="availability-tour-card__item_reviews__stars">
              </div>
              <div class="availability-tour-card__item_reviews__label">
                ${tour.reviews_count} ${__loco('reviews')}
              </div>
            </div>
            ` : ''}
          </div>
            </div>
            </div>
          </div>
        </article>`

    );
  }

  renderHotelCartItem(cartItem) {
    const roomTypes = cartItem.getRooms();
    const hotelTitle = cartItem.getTitle();

    return (
      `<article class="availability-tour-card__item border-none pb-0 mb-0">
            <div>
            <p class="availability-tour-card__item_title subtitle-2 secondary-text checkoutTourTitle border-bottom">${hotelTitle}</p>
            ${
              roomTypes.map((roomType) => {
                const image = roomType.images && roomType.images.length ? roomType.images[0] : null
                return `<div class="row no-gutters light-theme flex-nowrap mb-2">
                  <div class="col-5 col-lg-4 col-xl-4">
                    ${image ? `
                      <div class="tourImageWrapper">
                      <img class="item__left__slider_img-wrapp__image tourImage"
                           src="${image}" alt="${roomType.title}">
                      </div> 
                    ` : ''}
                  </div>
                  <div class="col-7 col-lg-8 col-xl-8">
                      <div class="availability-tour-card__item_content">
                  <p
                      class="availability-tour-card__item_title subtitle-2 secondary-text checkoutTourTitle"
                  >${roomType.title}</p>
                  
                  <div class="selected-date">
                      <button class="btn btn-default btn-sm btn-outline-dark" disabled>
                        <span class="selected-date-button-icon">
                            ${calendarIcon()}
                        </span>
                        <span class="selected-date-button-value caption">${moment(roomType.checkInDate).format('LL')} - ${moment(roomType.checkOutDate).format('LL')}</span>
                      </button>
                  </div>
                </div>
              </div>
            </div>`
              }).join('')
            }
            </div>
        </article>`

    );
  }

  handleCartValidationError() {
    $(this.selectors.mainWrapper).removeClass('--hidden').html(`<div class="checkout__content"><p class="checkout__h1">${__loco('Your cart contains invalid data.')}</p></div>`)
  }

  /**
   * Render guest information inputs and initialize payment handler object
   *
   * @param cartItems
   */

  renderGuestInformation(cartItems) {

    /**
     * Render guests form
     * @type {CheckoutGuestsInformationForm}
     */
    // const form = new CheckoutGuestsInformationForm();
    const form = new CheckoutGuestsInformationFormProvider().getCheckoutGuestsInformationForm();
    form.setItems(cartItems).setValidator(this.validator).renderForm();

    /**
     * Initialize order handler
     * @type {CheckoutOrderHandler}
     */
    const handler = new CheckoutOrderHandler();
    handler.setItems(cartItems).setValidator(this.validator).listen();

    // form.mock();
  }
}
